import {
    PAGE_TITLE_DESIGN,
    PAGE_TITLE_EMAIL_CONSTRUCTOR,
    PAGE_TITLE_FILTERS,
    PAGE_TITLE_MENU,
    PAGE_TITLE_NEWS,
    PAGE_TITLE_WINDOWS,
} from '#shared/lib/constants';
import { useExperimentFlag } from '#shared/lib/flags';
import {
    designRoute,
    emailConstructorRoute,
    filtersCategoryRoute,
    filtersCollectionAutoRoute,
    filtersCollectionRoute,
    filtersCommonRoute,
    filtersRootRoute,
    menuRoute,
    newsItemRoute,
    newsRoute,
    windowEditRoute,
    windowsRoute,
} from '#shared/lib/routes';
import { type MenuSection } from '../../types';
import { type SidebarMenuItem } from '../types';

const NEWS_MENU_ITEM: SidebarMenuItem = {
    href: newsRoute.getUrl(),
    permission: 'news',
    iconLabel: '',
    itemId: 'news',
    routes: [newsRoute.route, newsItemRoute.route],
    label: PAGE_TITLE_NEWS,
    title: PAGE_TITLE_NEWS,
};

const useShowEmailConstructor = (): boolean => useExperimentFlag('enable_email_constructor', 'exp');

export const FILTERS_MENU_ITEM: SidebarMenuItem = {
    href: filtersRootRoute.getUrl(),
    permission: 'editor',
    iconLabel: '',
    itemId: 'filters',
    routes: [
        filtersRootRoute.route,
        filtersCommonRoute.route,
        filtersCategoryRoute.route,
        filtersCollectionRoute.route,
        filtersCollectionAutoRoute.route,
    ],
    label: PAGE_TITLE_FILTERS,
    title: PAGE_TITLE_FILTERS,
};

export const EMAIL_CONSTRUCTOR_MENU_ITEM: SidebarMenuItem = {
    href: emailConstructorRoute.getUrl(),
    permission: 'editor',
    iconLabel: '',
    itemId: 'email-constructor',
    routes: [emailConstructorRoute.route],
    label: PAGE_TITLE_EMAIL_CONSTRUCTOR,
    title: PAGE_TITLE_EMAIL_CONSTRUCTOR,
    useShow: useShowEmailConstructor,
};

export const CONSTRUCTOR_MENU_SECTION: MenuSection = [
    {
        href: designRoute.getUrl(),
        permission: 'editor',
        iconLabel: '',
        itemId: 'design',
        routes: [designRoute.route],
        label: PAGE_TITLE_DESIGN,
        title: PAGE_TITLE_DESIGN,
        subMenuItems: [
            {
                href: menuRoute.getUrl(),
                permission: 'editor',
                iconLabel: '',
                itemId: 'menu',
                routes: [menuRoute.route],
                label: PAGE_TITLE_MENU,
                title: PAGE_TITLE_MENU,
            },
            FILTERS_MENU_ITEM,
            NEWS_MENU_ITEM,
            {
                href: windowsRoute.getUrl(),
                permission: 'editor',
                iconLabel: '',
                itemId: 'windows',
                routes: [windowsRoute.route, windowEditRoute.route],
                label: PAGE_TITLE_WINDOWS,
                title: PAGE_TITLE_WINDOWS,
            },
            EMAIL_CONSTRUCTOR_MENU_ITEM,
        ],
    },
];
